export const queryPage = '/icps/system/sign/cloudSell/collectMoney/queryPage'
export const queryPage1 = '/icps/system/sign/cloudSell/payerUnitManage/queryPage' //付款单位
export const Download = '/icps/system/sign/cloudSell/collectMoney/exportEngineeringNotes'
export const deleteNotes = '/icps/system/sign/cloudSell/collectMoney/deleteCollectMoney'
import request from '@/utils/request'
export function get_list_by_type(data) {
    return request({
        url: '/base/system/base/organization/get_list_by_type',
        method: 'get',
        params: data
    })
}
export function queryEngineering(data) {
    return request({
        url: '/icps/system/sign/cloudSell/notes/queryEngineering',
        method: 'get',
        params: data
    })
}
export function get_detail_code(data) {
    return request({
        url: '/base/system/base/dictionary/get_detail_codes',
        method: 'get',
        params: data
    })
}
export function saveOrUpdate(data) {
    return request({
        url: '/icps/system/sign/cloudSell/payerUnitManage/saveOrUpdate',
        method: 'POST',
        data
    })
}
export function completeNotes(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/updateCollectMoneyClaimMany',
        method: 'post',
        data
    })
}
// 批量确认
export function collectMoney(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/updateSureStatus',
        method: 'post',
        data
    })
}
export function saveOrUpdatecollectMoney(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/saveOrUpdate',
        method: 'POST',
        data
    })
}
export function deletePayUnit(data) {
    return request({
        url: '/icps/system/sign/cloudSell/payerUnitManage/deletePayUnit',
        method: 'POST',
        data
    })
}
export function queryPage2(data) {
    return request({
        url: '/icps/system/sign/cloudSell/payerUnitManage/queryList',
        method: 'POST',
        data
    })
}
export function queryCollectClaimList(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/queryCollectClaimList',
        method: 'POST',
        data
    })
}
export function updateCollectMoneyClaim(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/updateCollectMoneyClaim',
        method: 'POST',
        data
    })
}
export function queryDefaultSallers(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/queryDefaultSallers',
        method: 'get',
        params: data
    })
}
export function updateCollectMoneyFreeze(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/updateCollectMoneyFreeze',
        method: 'get',
        params: data
    })
}
export function sendMessionSaller(data) {
    return request({
        url: '/icps/system/sign/cloudSell/collectMoney/sendMessionSaller',
        method: 'POST',
        data
    })
}